import * as React from 'react';

var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPmPaypalVenmoBlackWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.889 6.25H32.11c.912 0 1.639.716 1.639 1.583v18.334c0 .867-.727 1.583-1.639 1.583H1.89c-.912 0-1.639-.716-1.639-1.583V7.833c0-.867.727-1.583 1.639-1.583z",
    fill: "#fff",
    stroke: "#08031D",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 10.652l.39.054c.86.12 1.599.607 2.037 1.295.268.421.423.918.423 1.45 0 1.54-1.296 2.772-2.874 2.772h-1.032a.383.383 0 00-.384.306l-.347 2a.882.882 0 01-.877.721H7.284c-.535 0-.965-.463-.878-1v-.003l.091-.517.481-2.776a.882.882 0 01.877-.72h1.17c1.445 0 2.6-1.126 2.6-2.492 0-.249-.037-.488-.108-.714l-.117-.376zm.689.63c.024.15.036.303.036.46 0 1.66-1.397 2.991-3.1 2.991h-1.17a.383.383 0 00-.384.306l-.481 2.777-.091.516c-.033.209.136.418.385.418h1.452a.383.383 0 00.384-.306l.347-2a.883.883 0 01.877-.721h1.032c1.32 0 2.374-1.027 2.374-2.273 0-.432-.126-.836-.345-1.18a2.367 2.367 0 00-1.316-.988z",
    fill: "#08031D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.024 14.483c1.575 0 2.851-1.228 2.851-2.742a2.645 2.645 0 00-.417-1.428A2.875 2.875 0 009.024 9H5.865a.632.632 0 00-.631.52l-1.226 7.543c-.06.373.239.71.631.71h2.104l.482-2.777a.633.633 0 01.63-.513h1.17zM23.063 24.755l-1.06-7.938a.283.283 0 01.252-.318l2.269-.226a.283.283 0 01.308.24l.71 4.955c.036.254.357.327.486.105 1.087-1.88 1.191-3.785 1.074-4.767a.3.3 0 01.234-.333l2.34-.467a.272.272 0 01.304.153c1.355 3.084-1.258 7.043-2.84 8.753a.275.275 0 01-.204.088h-3.592a.283.283 0 01-.28-.245z",
    fill: "#08031D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 25L25 9",
    stroke: "#08031D",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}

export { SvgPmPaypalVenmoBlackWhite as ReactComponent };
